import * as Yup from 'yup';

export const userGroupSchema = Yup.object().shape({
  description: Yup.string().required('Descrição é obrigatória.'),
});